module.exports = __webpack_public_path__ + "img/grey-kapla.cf15c3c6.png";